import { isSsr } from './general';

export const redirectToSignIn = (): void => {
  if (!isSsr) {
    window.location.replace(
      `/auth/view/signin?redirect=${window.location.pathname}`,
    );
  }
};

export const redirectToGuestOrderTracker = (): void => {
  if (!isSsr) {
    window.location.replace(`/myaccount/guest-order-tracking`);
  }
};
